var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product-filter" }, [
    _c(
      "button",
      {
        staticClass: "btn display-filter-btn",
        class: { "btn-bg-ts": _vm.brandName === _vm.Brand.Travelsphere },
        attrs: { "aria-label": "Open filter menu", title: "Open filter menu" },
        on: { click: _vm.viewMobileFilters },
      },
      [_vm._v(_vm._s(_vm.filterViewText))]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "filter" }, [
      _c(
        "div",
        {
          staticClass: "filter__header",
          class: { filter__headerTs: _vm.brandName === _vm.Brand.Travelsphere },
        },
        [
          _c("span", { staticClass: "filter__title", attrs: { dir: "ltr" } }, [
            _vm._v(_vm._s(_vm.filterText)),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "filter__clear hide-mobile",
              class: {
                filter__clear_ts: _vm.brandName === _vm.Brand.Travelsphere,
              },
              attrs: {
                "aria-label": "Clear all filters",
                title: "Clear all filters",
              },
              on: { click: _vm.clearAllFilters },
            },
            [_vm._v(_vm._s(_vm.filterClearText))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "filter__close",
              attrs: {
                "aria-label": "Close filter menu",
                title: "Close filter menu",
              },
              on: { click: _vm.hideMobileFilters },
            },
            [_vm._v(_vm._s(_vm.filterCloseText))]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "filter__container",
          class: {
            filter__containerTs: _vm.brandName === _vm.Brand.Travelsphere,
          },
        },
        [
          _vm._l(_vm.filters, function (filter, filterKey) {
            return [
              _c(filter.type, {
                key: filterKey,
                tag: "component",
                attrs: {
                  filter: filter,
                  filterKey: filterKey,
                  store: _vm.store,
                  "brand-name": _vm.brandName,
                },
              }),
            ]
          }),
          _vm._v(" "),
          _c("div", { staticClass: "filter__footer" }, [
            _c(
              "button",
              {
                staticClass: "btn filter__save-btn",
                class: {
                  "btn-bg-ts": _vm.brandName === _vm.Brand.Travelsphere,
                },
                attrs: {
                  "aria-label": "Apply filters",
                  title: "Apply filters",
                },
                on: { click: _vm.hideMobileFilters },
              },
              [_vm._v("Apply Filters")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "filter__clear",
                attrs: {
                  "aria-label": "Clear all filters",
                  title: "Clear all filters",
                },
                on: { click: _vm.clearAllFilters },
              },
              [_vm._v(_vm._s(_vm.filterClearText))]
            ),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }